export default "__VITE_ASSET__RxntCanq__"